export default {
  tableOne: [
    'gameName',
    'orderID',
    'round',
    'result'
  ],
  tableTwo: [
    'betTime',
    'endTime',
    'amendTime',
    'establishedTime',
    'betContents',
    'odds',
    'multiplier',
    'betAmount',
    'totalWin'
  ]
}
